import React from "react";
import { HiCheckBadge } from "react-icons/hi2";

const Backend = () => {
    return(
        <div className="skills__content">
        <h3 className="skills__title">Backend Developer</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Java</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Python</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Postgres</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
                
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">SpringBoot</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">MySQL</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
            </div>
            <div className="skills__group">
            <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Microserviços</h3>
                        <span className="skills__level">Intermediário</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Npm</h3>
                        <span className="skills__level">Intermediário</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Node.js</h3>
                        <span className="skills__level">Basico</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Rest API</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
                <div className="skills__data">
                    <HiCheckBadge />
                    <div>
                        <h3 className="skills__name">Git</h3>
                        <span className="skills__level">Avançado</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Backend;